import configurations from "./config.json"

const environment = process.env.REACT_APP_ENV || "local"
const config = configurations[environment as keyof typeof configurations]
if (!config)
  throw new Error(`Configuration not found for environment: ${environment}`)

const configWithEnv = { ...config, name: environment }
export default configWithEnv
